import React from 'react'
import Superface from '../Superface'

export default class Video extends React.Component {

    constructor(props) {
        super(props)
        this.handleResize = this.handleResize.bind(this)
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize)
    }

    handleResize(e) {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => { this.setState({}) }, 200)
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.handleResize)
    }

    renderVideo(){
        // console.log('render')
        const ratio = ( !Superface.IS_MOBILE_OR_TABLET ? 1920 / 1080 : 1 )
        const windowRatio = window.innerWidth / window.innerHeight

        const videoStyle = {
            objectFit: 'cover',
            width: windowRatio > ratio ? '100%' : 'auto',
            height: windowRatio < ratio ? '100%' : 'auto',
            transform : 'scale(1)'
        }
        if( !Superface.IS_MOBILE_OR_TABLET ){
            return <video ref={ el => this.video = el } type="video/mp4" style={videoStyle} muted="muted" src={this.props.src} loop="loop" autoPlay="autoplay" preload="auto" />
        }else{
            return <img style={videoStyle} src={this.props.backupSrc} />
        }
    }

    render() {

       
        const style = {
            position: 'absolute',
            zIndex: 200,
            width: '100%',
            height: '100%',
            left: '0%',
            overflow: 'hidden'
        }

       

        return (
            
            <div ref={ this.props.setRef } style={style}>
                <div id="home-video" style={style}>
                    {this.renderVideo()}
                </div>
            </div>
            
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/HomeVideo.js